<template>
  <Error
    title="ページが見つかりません"
    lead="お探しのページは見つかりません"
  >
    <template #default>
      お探しのページは、削除されたか、名前が変更された可能性があります。
    </template>
  </Error>
</template>

<script>
import Error from '@/components/Error.vue'

export default {
  navbar: false,
  components: {
    Error
  },
  metaInfo() {
    return {
      title: 'ページが見つかりません',
      bodyAttrs: { class: 'error' }
    }
  }
}
</script>
